import React from "react";
import { useTranslation } from "react-i18next";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

interface FormTabsProps {
  tab: 'details' | 'attachments';
  add: boolean;
  onTabChange: (e: any, value: 'details' | 'attachments') => void;
}

const FormTabs: React.FC<FormTabsProps> = ({ tab, add, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="card-header overflow-hidden no-padding">
      <Tabs value={tab} onChange={onTabChange} textColor='primary'>
        <Tab value="details" label={t("transactions.addEdit.pageTexts.form.tabs.details")} />
        {!add && <Tab value="attachments" label={t("transactions.addEdit.pageTexts.form.tabs.attachments")} />}
      </Tabs>
    </div>
  );
};

export default FormTabs;
